
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import ButtonVue from "@/lib/Button.vue";
import { IUser } from "@/../../server/src/user/IUser";
import { Finder, IFinder } from "@/finder/IFinder";
import FinderInlineVue from "@/finder/FinderInline.vue";

import { Task } from "../../server/src/task/Task";
import { ITask } from "../../server/src/task/ITask";
import { TaskSvc } from "./TaskSvc";
import { ITaskParent } from "../../server/src/task/ITaskParent";
import { ITaskSearcher } from "../../server/src/task/ITaskSearcher";
import { DateString } from "@/DateString";
import ModalVue from "@/Modal.vue";

import TaskShowVue from "./TaskShow.vue";
import TaskSendVue from "./TaskSend.vue";


@Component({  name: 'TasksVue', components: { FinderInlineVue, ButtonVue, ModalVue, TaskShowVue, TaskSendVue } })
export default class TasksVue extends Vue {

  @Prop(Object) parent!: ITaskParent;
  @Prop(String) re_id!: string;
  key = 0;
  tasks: ITask[] = [];

  created() {
    bus.register("task_list_refresh",this.refresh)
  }

  beforeDestroy() {
    bus.remove("task_list_refresh",this.refresh)
  }

  async mounted() {
    await this.refresh();
  }

  async refresh() {
    let ops_id: any = null;
    let lbl_id: any = null;
    let prj_id: any = null;

    const searcher: ITaskSearcher = {
      lbl_id: this.parent.lbl_id,
      prj_id: this.parent.prj_id,
      ops_id: this.parent.op_id,
      re_id: this.re_id
    };
    this.tasks = await new TaskSvc().find(searcher);
    console.log("task refresh ended")
    await this.select_input()
    this.key++
  }

  async select_input() {
    if (this.$refs.ref_uwagi) {
      this.$nextTick( () => (<any>this.$refs.ref_uwagi).focus() )
    }
  }

}
